import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

export default function StatsPage() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/admin/stats")
      .then(({ data }) => setStats(data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || e.message));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-stats-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">// Analyse</p>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight">Statistiques détaillées</h1>
      </div>

      {error && <p className="text-destructive text-sm">{error}</p>}

      {stats && (
        <section className="border border-border bg-card rounded-sm p-6">
          <h2 className="font-bold tracking-tight mb-4">Clics par lien</h2>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={stats.top_links.map((l) => ({ name: l.title, clicks: l.clicks }))}
                margin={{ top: 16, right: 16, left: -16, bottom: 60 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis
                  dataKey="name"
                  stroke="hsl(var(--muted-foreground))"
                  fontSize={11}
                  angle={-30}
                  textAnchor="end"
                  interval={0}
                  height={60}
                />
                <YAxis allowDecimals={false} stroke="hsl(var(--muted-foreground))" fontSize={11} />
                <Tooltip
                  contentStyle={{
                    background: "hsl(var(--popover))",
                    border: "1px solid hsl(var(--border))",
                    borderRadius: 4,
                    fontSize: 12,
                  }}
                />
                <Bar dataKey="clicks" fill="hsl(var(--primary))" radius={[2, 2, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </section>
      )}
    </div>
  );
}
